export default __webpack_public_path__ + "static/media/NationalWeb-Bold.f37e4d70.eot";